// extracted by mini-css-extract-plugin
export default {"search":"search___a3b5610bfe48f640b1da"};